import FormBase from "../FormBase";
import FormFieldBase from "../../forms/FormFieldBase";
import ValidationBase, { ValidationType } from "../../forms/ValidationBase";
import Professional from '../../models/Professional'
import AcademicService from "../../services/AcademicDegreeService";

export class AcademicDegreeFormItem {
    Id: number;
    Title: string;
    TitleValue: any
    Institution: string;
    YearCompletion: string;
    Course: string;

    constructor(Id: number, Title: any, Institution: string, Course: string, YearCompletion: string) {
        this.Id = Id;
        this.Title = Title.Text;
        this.TitleValue = Title;
        this.Institution = Institution;
        this.Course = Course;
        this.YearCompletion = YearCompletion;
    }

    static NewInstance(): AcademicDegreeFormItem {
        return new AcademicDegreeFormItem(0, "", "", "", "");
    }

}

export default class AcademicDegreeForm implements FormBase {

    Title: FormFieldBase;
    Institution: FormFieldBase;
    YearCompletion: FormFieldBase;
    Course: FormFieldBase;
    AcademicDegreeFormItemList: AcademicDegreeFormItem[];
    AcademicDegreeFormItemToEdit: AcademicDegreeFormItem;

    constructor(Title: string, Institution: string, Course: string, YearCompletion: string) {

        this.Title = new FormFieldBase(Title, [], () => "", (value: any) => { this.InputChangeCustom(value) });
        this.Institution = new FormFieldBase(Institution, [], () => "", (value: any) => { this.InputChangeCustom(value) });
        this.YearCompletion = new FormFieldBase(YearCompletion, [], () => "", (value: any) => { this.InputChangeCustom(value) });
        this.Course = new FormFieldBase(Course, [], () => "", (value: any) => { this.InputChangeCustom(value) });
        this.AcademicDegreeFormItemList = new Array<AcademicDegreeFormItem>();
        this.AcademicDegreeFormItemToEdit = AcademicDegreeFormItem.NewInstance();
    }

    CallInsertOrUpdateApi(Professional: Professional): Promise<boolean> {
        if (this.AcademicDegreeFormItemList != null && this.AcademicDegreeFormItemList.length > 0) {
            const dataJson = this.getJsonObjet();
            return AcademicService.postInsertOrUpdateAcademic(dataJson, Professional.Id);
        } else {
            return Promise.resolve(true);
        }
    }


    AddOrUpdateAcademicDegreeFormItem() {

        this.Title.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
        this.Institution.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
        this.YearCompletion.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
        this.Course.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];

        this.Title.Mandatory = true;
        this.Institution.Mandatory = true;
        this.YearCompletion.Mandatory = true;
        this.Course.Mandatory = true;

        if (this.ValidateForm()) {

            if (this.AcademicDegreeFormItemToEdit === null || this.AcademicDegreeFormItemToEdit.Id === 0) {

                let academicDegreeFormItem = new AcademicDegreeFormItem(
                    this.getNewId(),
                    this.Title.Value,
                    this.Institution.Value,
                    this.Course.Value,
                    this.YearCompletion.Value
                )

                this.AcademicDegreeFormItemList.push(academicDegreeFormItem);
            } else {
                for (let index = 0; index < this.AcademicDegreeFormItemList.length; index++) {
                    const element = this.AcademicDegreeFormItemList[index];
                    if (element.Id === this.AcademicDegreeFormItemToEdit.Id) {

                        let academicDegreeFormItem = new AcademicDegreeFormItem(
                            element.Id,
                            this.Title.Value,
                            this.Institution.Value,
                            this.Course.Value,
                            this.YearCompletion.Value
                        )

                        this.AcademicDegreeFormItemList[index] = academicDegreeFormItem;
                    }
                }
            }
            this.ResetForm();
        }
    }

    EditAcademicDegreeFormItem(id: number) {
        this.ResetForm();

        for (let index = 0; index < this.AcademicDegreeFormItemList.length; index++) {
            const element = this.AcademicDegreeFormItemList[index];

            if (element.Id === id) {
                this.AcademicDegreeFormItemToEdit = element;
                this.Title.Value = this.AcademicDegreeFormItemToEdit.TitleValue;
                this.Institution.Value = this.AcademicDegreeFormItemToEdit.Institution;
                this.Course.Value = this.AcademicDegreeFormItemToEdit.Course;
                this.YearCompletion.Value = this.AcademicDegreeFormItemToEdit.YearCompletion;
            }
        }
    }

    RemoveAcademicDegreeFormItem(id: number) {
        for (let index = 0; index < this.AcademicDegreeFormItemList.length; index++) {
            const element = this.AcademicDegreeFormItemList[index];
            if (element.Id === id) {
                this.AcademicDegreeFormItemList.splice(index, 1);
            }
        }
    }

    ValidateToGoNextStep(): string {
        return "";
    }

    InputChangeCustom(Value: any): void {

        if (Value != null && Value !== "") {

            this.Title.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
            this.Institution.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
            this.YearCompletion.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
            this.Course.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];

            this.Title.Mandatory = true;
            this.Institution.Mandatory = true;
            this.YearCompletion.Mandatory = true;
            this.Course.Mandatory = true;

        } else {

            let propNames = Object.getOwnPropertyNames(this);

            let existFieldImputed = false;

            for (let index = 0; index < propNames.length; index++) {
                const element = propNames[index];
                const value = this.GetFieldByName(element).Value;

                if (value != null && value !== "" && value.toString().trim() !== "") {
                    existFieldImputed = true;
                }
            }

            if (existFieldImputed) {
                this.Title.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
                this.Institution.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
                this.YearCompletion.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
                this.Course.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];

                this.Title.Mandatory = true;
                this.Institution.Mandatory = true;
                this.YearCompletion.Mandatory = true;
                this.Course.Mandatory = true;
            } else {
                this.Title.Validations = [];
                this.Institution.Validations = [];
                this.YearCompletion.Validations = [];
                this.Course.Validations = [];
                this.Title.Error = "";
                this.Institution.Error = "";
                this.YearCompletion.Error = "";
                this.Course.Error = "";
                this.Title.Mandatory = false;
                this.Institution.Mandatory = false;
                this.YearCompletion.Mandatory = false;
                this.Course.Mandatory = false;
            }
        }
    }

    static NewInstance(): AcademicDegreeForm {
        return new AcademicDegreeForm("", "", "", "");
    }

    ValidateForm(): boolean {
        let propNames = Object.getOwnPropertyNames(this);

        let formIsValid = true;

        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            const error = this.GetFieldByName(element).ValidateField();

            if (error !== null && error !== "") {
                formIsValid = false;
            }
        }

        return formIsValid;
    }

    ResetForm(): void {
        let propNames = Object.getOwnPropertyNames(this);
        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            this.GetFieldByName(element).Value = "";
            this.GetFieldByName(element).Error = "";
        }

        this.AcademicDegreeFormItemToEdit = AcademicDegreeFormItem.NewInstance();
    }

    GetFieldByName(name: string): FormFieldBase {
        switch (name) {
            case "Title":
                return this.Title
            case "Institution":
                return this.Institution
            case "YearCompletion":
                return this.YearCompletion
            case "Course":
                return this.Course

            default:
                return new FormFieldBase("", []);
        }
    }


    getNewId(): number {
        if (this.AcademicDegreeFormItemList.length > 0) {
            let maxId = Math.max.apply(Math, this.AcademicDegreeFormItemList.map(function (o) { return o.Id; }))
            return maxId + 1;
        } else {
            return 1;
        }
    }

    getJsonObjet(professionalId: number = 0) {

        let viewModelList: any[] = [];

        if (this.AcademicDegreeFormItemList != null && this.AcademicDegreeFormItemList.length > 0) {
            this.AcademicDegreeFormItemList.forEach((element: AcademicDegreeFormItem) => {
                viewModelList.push({
                    "professionalId": professionalId,
                    "titleId": element.TitleValue.Id,
                    "institutionName": element.Institution,
                    "courseName": element.Course,
                    "yearCompletion": parseInt(element.YearCompletion)
                })
            });
        }

        return viewModelList;
    }
}